import {
  isLocalDev,
  isImagitasDev,
  isImagitasTest,
  isUspsDev,
  isUspsCat,
  isUspsSit,
} from '@mgo/core/src/environment';

export default function () {
  const origin = window.location.href;
  switch (true) {
    case isLocalDev(origin):
    case isImagitasDev(origin):
    case isImagitasTest(origin):
    case isUspsDev(origin):
    case isUspsSit(origin):
      // eslint-disable-next-line no-console
      console.log('Not Production Ampersend');
      return 'hZbD57m7jGuG90XgcZMpGSvnZ8WCqZz9sVCIVUc6QZo=';

    case isUspsCat(origin):
    default:
      return 'AgrmZAdqapGxIPVdEzQJHpW6ykIH7QMhrS5R1+1yc2E=';
  }
}
